import { jsx as p, jsxs as _ } from "react/jsx-runtime";
import { c as i } from "./Section-DOeCOW54.js";
import n from "react";
const d = "elo-picture", w = "elo-picture__zoom", e = {
  "picture-wrapper": "elo-picture-wrapper",
  "picture-wrapper__picture--outer": "elo-picture-wrapper__picture--outer",
  picture: d,
  picture__zoom: w
}, x = n.forwardRef(
  ({ src: r, alt: o, zoom: u, defaultSrc: s, wrapperClassName: m, ...t }, l) => {
    const a = i(
      e.picture,
      u && e.picture__zoom,
      t.className
    );
    return /* @__PURE__ */ p(
      "div",
      {
        ref: l,
        className: i(e["picture-wrapper"], m),
        children: /* @__PURE__ */ _("picture", { ...t, className: i(e["picture-wrapper__picture--outer"], t.className), children: [
          r == null ? void 0 : r.map((c) => /* @__PURE__ */ p(
            "source",
            {
              media: c.media,
              srcSet: c.src,
              className: a
            },
            c.src
          )),
          /* @__PURE__ */ p("img", { src: s, alt: o, className: a, loading: "lazy" })
        ] })
      }
    );
  }
);
export {
  x as P
};
